import * as React from 'react';
import cx from 'classnames';
import styles from './style.scss';

export default function AccessibleSpan({
  className,
  onClick,
  children,
  disabled = false,
  role = 'button',
}: {
  className?: string;
  onClick: (event: any) => void;
  children: React.ReactNode;
  disabled?: boolean;
  role?: 'link' | 'button';
}) {
  const handleKeyDown = (event: React.KeyboardEvent<HTMLSpanElement>) => {
    if (
      (event.key === 'Enter' || (event.key === ' ' && role === 'button')) &&
      !disabled
    ) {
      event.stopPropagation(); // prevent enter from submitting form
      onClick(event); // trigger onClick if space (only for button) or enter is pressed
    }
  };

  return (
    <span
      role={role}
      tabIndex={disabled ? -1 : 0}
      className={cx(styles.span, disabled && styles.disabled, className)}
      onClick={event => {
        if (disabled) {
          return;
        }
        event.currentTarget.blur(); // prevent clicking from highlighting the span
        onClick(event);
      }}
      onKeyDown={handleKeyDown}
    >
      {children}
    </span>
  );
}
